import { EventViewTypes, SportIds } from 'constants/app';
import { BettingTypes } from 'constants/markets';
import { IEventViewSettings } from 'redux/modules/appConfigs/type';
import { TCurrentBet } from 'redux/modules/currentBets/type';

export const getIsUnderOverLabel = ({
  enableLineMarketsBranding,
  sportId,
  bettingType
}: {
  sportId: number;
  enableLineMarketsBranding: boolean;
  bettingType: string;
}) => {
  return enableLineMarketsBranding && sportId.toString() !== SportIds.CRICKET && bettingType === BettingTypes.LINE;
};

export const getIsFancyMarket = (
  betItem: TCurrentBet,
  eventViewSettings: IEventViewSettings[],
  enableFancyMarketsViewOnCricket: boolean
) => {
  if (!!betItem.fancyView) {
    const eventSettings = eventViewSettings.find(event => event.eventTypeId === betItem.eventTypeId.toString());

    return enableFancyMarketsViewOnCricket && eventSettings?.viewType !== EventViewTypes.TOP_5_VIEW;
  }

  return false;
};

export const getIsYesNoLabel = (
  bet: TCurrentBet,
  eventViewSettings: IEventViewSettings[],
  enableFancyMarketsViewOnCricket: boolean,
  sportId: number
) =>
  getIsFancyMarket(bet, eventViewSettings, enableFancyMarketsViewOnCricket) && sportId.toString() === SportIds.CRICKET;

export const getEventTime = (marketStartDate: number): string => {
  const date = new Date(marketStartDate);
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${hours}:${minutes}`;
};

export const getIsRaceType = (eventTypeId: number) =>
  [
    SportIds.GRAY_HOUND_RACING,
    SportIds.HORSE_RACING,
    SportIds.TODAY_GRAY_HOUND_RACING,
    SportIds.TODAY_HORSE_RACING
  ].includes(String(eventTypeId) as '4339' | '7' | 'tc-7' | 'tc-4339');
